import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState, IMultiEditingGroupsProps, IMultiEditingPickerField} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import { Context } from "routes/private/Editor/Context";
import MultiEditingFields from './fields';
import ComboBox from '@components/ComboBox';
import { findSelectedCategoryInGroup } from '@utils/multiEditing';
import { getMultiEditingFieldsForPicker, findIElementGroupByMultiEditingCategory } from '@utils/multiEditing'
import { endsWithNumber, getEndNumber } from '@utils/selectDescribe'

const MultiEditingGroups:React.FC<IMultiEditingGroupsProps> = (props) => {
    const [categorySelected,setCategorySelected] = useState<string>();
    const [fields,setFields] = useState<IMultiEditingPickerField[]>([]);
    let context = useContext(Context);
    let endNumber: number|undefined;

    if (endsWithNumber(props.name)) {
        endNumber = getEndNumber(props.name);
    }
    
    useEffect(() => {
        const selectedCategory = findSelectedCategoryInGroup(props.id, context.multiEditingConfig!, context.data, context.selectDescribe?.taggedFields);
        setCategorySelected(selectedCategory);
    }, [context.data])

    useEffect(() => {
        if (context.multiEditingConfig && categorySelected) {
            const fieldsPicker = getMultiEditingFieldsForPicker(categorySelected, context.multiEditingConfig, context.data, context.selectDescribe?.taggedFields);            
            setFields(fieldsPicker);
        }
    }, [categorySelected])

    const selectFields = (categoryId: string) => {
        if (context.multiEditingConfig && categoryId) {
            const fields = getMultiEditingFieldsForPicker(categoryId, context.multiEditingConfig, context.data, context.selectDescribe?.taggedFields);
            const selectDescribeFields = fields.map((field) => { return field.selectDescribeFieldId; });
            context.onMultiEditingFocus(selectDescribeFields);
        }
    }

    const handleSelectOption = (id: string, value: string) => {        
        if (id === "categoriesME") {
            const categoryId = findCategoryId(value);
            setCategorySelected(categoryId);
            let elementsIds: string[] = [];
            let hiddes: string[] = [];
            for (let i=0;i<props.categories.length;i++) {
                const iElementsGroup = findIElementGroupByMultiEditingCategory(props.categories[i].id, context.multiEditingConfig!, context.data, context.selectDescribe?.taggedFields??[]);                
                elementsIds = elementsIds.concat(iElementsGroup);
                for (let a=0;a<iElementsGroup.length;a++) {
                    if (props.categories[i].id !== categoryId) {
                        hiddes.push("true");
                    }
                    else {
                        hiddes.push("false");
                    }
                }
            }                        
            context.onCommandChange("hideUnhide",undefined,elementsIds,hiddes);
            selectFields(categoryId);
        }
    }

    const findCategoryId = (name: string): string => {
        for (let i=0;i<props.categories.length;i++) {
            if (props.categories[i].name === name + (endNumber!==undefined?" " + endNumber.toString():"")) return props.categories[i].id;
        }
        return "";
    }

    const findCategoryName = (id: string|undefined): string => {
        if (!id) return "";
        for (let i=0;i<props.categories.length;i++) {
            if (props.categories[i].id === id) return props.categories[i].name;
        }
        return "";
    }

    const removeEndNumber = (text: string): string => {
        if (endNumber === undefined) return text;
        return text.replace(new RegExp(" " + endNumber.toString() + '$'), '');
    }

    return (
        <>
            <ComboBox
            id="categoriesME"
            placeholder=""
            options={props.categories.map((category)=> {return removeEndNumber(category.name)})}
            required={false}
            disabled={false}
            position={"bottom"}
            chooseOption={handleSelectOption}
            value={removeEndNumber(findCategoryName(categorySelected))}
            containerStyle={{
                padding: "0px",
                width: "100%",
            }}
            optionContainerStyle={{
                padding: `0px 0px`,
            }}
            optionStyle={{
                fontSize: `16px`,
                color: `#272727`,
                padding: `10px 14px`,
            }}
            style={{
                fontSize: `14px`,
                color: `${C.BLUE}`,
                fontFamily: `Roboto`,
                padding: `0px 6px`,
            }}
            titleStyle={{
            }}
            />
            <S.LineSeparator/>
            {
                fields.map((field, index) => {
                return (
                    <MultiEditingFields
                        key={index}
                        id={field.id}
                        elementType={field.elementType}
                        selectDescribeFieldId={field.selectDescribeFieldId}
                        categoryId={field.categoryId}
                        name={field.name}
                    />
                )
            })
        }
        </>
    );
}

export default MultiEditingGroups;